/**
* @module index
* @author: zhangyemei
* @description:
* @since: 2020-05-23 17:52:42
*/
import React, { Component } from 'react';
import { Decrypt, Encrypt } from '@/utils/encrypt.js';
import { Dropdown, Menu, Input } from 'antd';
import history from '@/router/history';
const {
  SubMenu
} = Menu;
import QRCode from 'qrcode.react';
import { Local } from '@/utils/local.js';
import { footerThemeColor } from '@/utils/themeColor.js';
import intl from 'react-intl-universal';
import LogoSchool from '../LogoSchool';
import UserInfo from '../UserInfo';
import './style.less';

const logoUrl = require('@/statics/img/logo.png');

export default class index extends Component {
  state = {
    userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : null,
    baseUrl: window.location.origin,
    baseInfo: this.props.baseInfo,
    schoolList: this.props.schoolList,
    headMenuList: this.props.headMenuList,
    personConfigInfo: this.props.personConfigInfo,
    currentUserInfo: this.props.currentUserInfo,
    appConfig: this.props.appConfig,
    learnData: this.props.learnData,
    origin: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev-s.yunduoketang.cn'
  };

  componentDidMount() {}

  searchCourse = value => {
    value = encodeURI(value);
    history.push(`/course/list?courseName=${value}`); // window.open(`${this.state.origin}/sysConfigItem/showList?n=${value}`)
  };

  render() {
    const {
      state
    } = this;
    const {
      schoolList,
      showSchoolList,
      baseInfo,
      currentSchoolName,
      appConfig,
      personConfigInfo,
      currentUserInfo,
      personal,
      unreadMessage,
      lateLearnShow,
      headMenuList,
      learnData,
      dropVisible,
      currentMenu
    } = this.props; // console.log('this.props.currentMenu',this.props.currentMenu);
    //APP下载

    const appLoad = <div data-inspector-line="56" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="load-box">
        <div data-inspector-line="57" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="load-top">
          {appConfig.scanDownURL ? <img data-inspector-line="59" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="img-qrcode" src={appConfig.scanDownURL} alt="" /> : null}
          {appConfig.iosDownURL || appConfig.androidDownURL ? <div data-inspector-line="62" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="load-type">
              <p data-inspector-line="63" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx">手机客户端下载</p>
              {appConfig.iosDownURL ? <p data-inspector-line="65" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx">
                  <i data-inspector-line="66" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="iconfont iconpingguo"></i>
                  <a data-inspector-line="67" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" href={appConfig.iosDownURL} target="_blank">iphone下载</a>
                </p> : null}
              {appConfig.androidDownURL ? <p data-inspector-line="71" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx">
                  <i data-inspector-line="72" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="iconfont iconanzhuo"></i>
                  <a data-inspector-line="73" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" href={appConfig.androidDownURL} target="_blank">安卓下载</a>
                </p> : null}
            </div> : null}
        </div>

        {appConfig.schoolURL ? <div data-inspector-line="81" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="load-bottom">
            <QRCode data-inspector-line="82" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="img-qrcode" size={112} fgColor="#000000" value={appConfig.schoolURL} />
            <div data-inspector-line="88" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx">打开APP，扫描网校二维码进入学习</div>
          </div> : null}
      </div>;
    return <div data-inspector-line="96" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="navbg">
        <div data-inspector-line="97" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="shadow-bottom">

          <div data-inspector-line="99" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="navbar navbar_elegant cf">
            <LogoSchool data-inspector-line="100" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" {...{
            schoolList,
            showSchoolList,
            baseInfo,
            currentSchoolName,
            dropVisible
          }} handleSchoolClick={this.props.handleSchoolClick} showDorpMenu={this.props.showDorpMenu} history={this.props.history} />

            <Menu data-inspector-line="105" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="nav-menu" onClick={this.props.handleNavMenuClick} selectedKeys={[this.props.currentMenu]} mode="horizontal">
              {headMenuList.map((item, index) => <SubMenu data-inspector-line="112" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" key={index} className={`submenu ${this.props.currentMenu == index ? 'ant-menu-item-selected' : ''}`} title={<span data-inspector-line="116" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="submenu-title-wrapper" onMouseOver={() => this.props.handleMenuMouseOver(item)} onClick={() => this.props.handleMenuClick(item, 'head', index)}>
                      {item.menuName}
                    </span>}>
                  {item.subMenu.map((subItem, subIndex) => <Menu.Item data-inspector-line="125" data-inspector-column="22" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" key={subIndex} onClick={() => this.props.handleMenuClick(subItem, 'head', subIndex)}>{subItem.menuName}</Menu.Item>)}
                </SubMenu>)}
            </Menu>

            <div data-inspector-line="132" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="right">
              {
              /* <span className="csp" onClick={this.props.handleSwitchLang}>{this.props.langText}</span> */
            }
              <input data-inspector-line="134" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" type="password" style={{
              display: 'none'
            }} />
              <Input.Search data-inspector-line="135" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" style={{
              width: '200px',
              marginLeft: '20px'
            }} onSearch={value => this.searchCourse(value)} placeholder="搜索你感兴趣的课程" />
              {//APP下载
            personConfigInfo.includes('HEAD_APP') && appConfig && !appConfig.appConfigStatus ? <Dropdown data-inspector-line="138" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="user-info" overlay={appLoad}>
                    <div data-inspector-line="139" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="app-download-wrap" onClick={this.props.goToAppDown}><i data-inspector-line="139" data-inspector-column="88" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" className="iconfont iconshouji">&nbsp;</i>{intl.get('appDownLoad')}</div>
                  </Dropdown> : null}
              <UserInfo data-inspector-line="142" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\ElegantHeader\\index.jsx" {...{
              appConfig,
              currentUserInfo,
              personal,
              unreadMessage,
              lateLearnShow,
              personConfigInfo,
              learnData
            }} changeMenu={this.props.changeMenu} />
            </div>
          </div>
        </div>
      </div>;
  }

}